import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M18 19C18 19.552 17.552 20 17 20H7C6.449 20 6 19.552 6 19V7C6 6.449 6.449 6 7 6H12V4H7C5.346 4 4 5.346 4 7V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V12H18V19Z"
      fill="currentColor"
    />
    <path d="M10 14H12.505L19.648 6.85799L17.134 4.34399L10 11.471V14Z" fill="currentColor" />
    <path
      d="M20.9471 3.01995C20.1581 2.23095 19.4571 2.02795 19.4571 2.02795L17.6101 3.87495L20.1251 6.38995L21.9721 4.54295C21.9721 4.54195 21.7361 3.80895 20.9471 3.01995V3.01995Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'NewMessage');

export default Icon;
